import ControlFactory from '@/Factories/ControlFactory';
import AssociationSingleAutocompleteBoxViewModel from '@/ViewModels/Controls/AssociationSingleAutocompleteBoxViewModel';
import AssociationSingleAutocompleteBox from '@/Controls/AssociationSingleAutocompleteBox';
import { IRefreshable } from '#/DefaultViewExtensionInterfaces';
import AssociationSingleAutocompleteBoxViewModelT from '@/ViewModels/Controls/AssociationSingleAutocompleteBoxViewModel';
import MultiSelectAutoCompleteViewModelT from '@/ViewModels/Controls/MultiSelectAutoCompleteViewModel';
import LinkViewModelT from '@/ViewModels/Controls/LinkViewModel';
import ImageViewModelT from '@/ViewModels/Controls/ImageViewModel';
import SearchListViewViewModelT from '@/ViewModels/Views/SearchListViewViewModel';
import LabelViewModelT from '@/ViewModels/Controls/LabelViewModel';
import Loader from '@/Utility/Loader';
import NavigationService from '@/Management/NavigationService';
import RADApplication from '@/Management/RADApplication';
import ComponentManager from '@/Management/ComponentManager';
import Config from '@/Management/GlobalConfiguration';
import RADEnvironmentProxy from '@/Communication/RADEnvironmentProxy';
import FilterHelper from '@/Utility/FilterHelper';
import LocatorHelper from '@/Utility/LocatorHelper';
export default class AssociationSingleAutocompleteBoxFactory extends ControlFactory implements IRefreshable {
    /** @overrides */
    public control: AssociationSingleAutocompleteBox;
    /** @overrides */
    public viewModel: AssociationSingleAutocompleteBoxViewModel;
    private jQueryControl; JQuery;
    /** @overrides */
    public orderStatement: any;
    public containsMode: boolean;
    public maxSuggestions: number;
    public searchFields: string;
    public minLength: number;
    public pdoId: any;
    public objectIdentValue: any;
    public iterator: any;
    public isModalCreating: any;
    public forceReloadData: any;
    private AssociationSingleAutocompleteBoxViewModel: any;
    private AssociationSingleAutocompleteBox: any;
    private ObjectConnectionHelper: any;
    private ObjectDisconnectionHelper: any;
    private ObjectDeletionHelper: any;
    private ObjectCreationHelper: any;
    private _objectHelper: any;
    private MultiSelectAutoCompleteViewModel: any;
    protected LinkViewModel: any;
    protected ImageViewModel: any;
    private SearchListViewViewModel: any;
    protected LabelViewModel: any;
    private viewFactorySearchListView: any;
    constructor(protected params: any) {
        super(params);
        this.AssociationSingleAutocompleteBoxViewModel = ComponentManager.getViewModel<typeof AssociationSingleAutocompleteBoxViewModelT>('AssociationSingleAutocompleteBoxViewModel');
        this.AssociationSingleAutocompleteBox = ComponentManager.getControl('AssociationSingleAutocompleteBox');
        this.ObjectConnectionHelper = ComponentManager.getUtility('ObjectConnectionHelper');
        this.ObjectDisconnectionHelper = ComponentManager.getUtility('ObjectDisconnectionHelper');
        this.ObjectDeletionHelper = ComponentManager.getUtility('ObjectDeletionHelper');
        this.ObjectCreationHelper = ComponentManager.getUtility('ObjectCreationHelper');
        this._objectHelper = null;
        this.MultiSelectAutoCompleteViewModel = ComponentManager.getViewModel<typeof MultiSelectAutoCompleteViewModelT>('MultiSelectAutoCompleteViewModel');
        this.LinkViewModel = ComponentManager.getViewModel<typeof LinkViewModelT>('LinkViewModel');
        this.ImageViewModel = ComponentManager.getViewModel<typeof ImageViewModelT>('ImageViewModel');
        this.SearchListViewViewModel = ComponentManager.getViewModel<typeof SearchListViewViewModelT>('SearchListViewViewModel');
        this.LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModelT>('LabelViewModel');
        this.pdoId = this.context.genericObject.getObservable(this.detailViewItem.name + '.PDO_ID');
        this.objectIdentValue = this.context.genericObject.getObservable(this.detailViewItem.name + '.ObjectIdentValue');
        this.iterator = null;
        this.viewFactorySearchListView = null;
        this.isModalCreating = this.paramOrDefault(params.isModalCreating, false);
        this.registerForMessageId('RefreshAssociationsMessage', () => {
            if (this.isDisposed == false && this.context.isDisposed == false)
                this.refreshAssociation();
        });
    }
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }
        this.context.genericObject.suppressNotificationFor(this.detailViewItem.name + '.PDO_ID');
        this.context.genericObject.suppressNotificationFor(this.detailViewItem.name + '.ObjectIdentValue');
        this.orderStatement = this.paramOrDefault(this.params.orderStatement, this.detailViewItem.listView.defaultOrder);
        this.containsMode = this.paramOrDefault(this.params.isContainsMode, true);
        this.maxSuggestions = this.paramOrDefault(this.params.maxSuggestions, 150, (val, def) => {
            if (!isNaN(val) && (val * 1) > 0) {
                return val * 1;
            }
            else {
                return def;
            }
        });
        this.searchFields = this.paramOrDefault(this.params.searchFields, 'ObjectIdentValue');
        this.minLength = this.paramOrDefault(this.params.minLength, 1);
        this.viewModel = (() => {
            let associationSingleAutocompleteBoxViewModel = new this.AssociationSingleAutocompleteBoxViewModel({
                parentLocator: this.locator,
                locator: this.detailViewItem.name,
                tooltip: new this.LabelViewModel({
                    ergName: this.detailViewItem.tooltip
                }),
                factory: this,
                isRequired: this.isRequired,
                isEnabled: this.isEnabled,
                isValid: this.isValid,
                isBusy: this.isBusy,
                multiSelectAutoComplete: new this.MultiSelectAutoCompleteViewModel({
                    parentLocator: this.locator,
                    locator: LocatorHelper.buildLocator(this.detailViewItem.name, 'autocomplete'),
                    containsMode: this.containsMode,
                    dataTextField: 'objectIdentValue',
                    dataValueField: 'pdoId',
                    isFocusable: this.isFocusable,
                    minLength: this.minLength,
                    maxSelectedItems: 1,
                    dataSource: (() => {
                        return new kendo.data.DataSource({
                            transport: {
                                read: (options) => {
                                    //Wenn die DV schnell verlassen wir, dann muss dies hier abgefangen werden
                                    if (!this || !this.viewModel || !this.viewModel.multiSelectAutoComplete) {
                                        return;
                                    }
                                    // if a value is set, the data-array is equal to that value, no request has to be made in this case
                                    let currentValues = this.viewModel.multiSelectAutoComplete.values();
                                    if (!_.isEmpty(currentValues)) {
                                        options.success([currentValues[0]]);
                                        return;
                                    }
                                    this.deleteIterator(this.iterator);
                                    // otherwise request value-candidates from server
                                    let pdTypeName = this.detailViewItem.listView.typeName;
                                    // add a filter to the request, in case that any filter-input is given
                                    let filter = this.assembleFilter(options, pdTypeName);
                                    this.isBusy(true);
                                    RADEnvironmentProxy.getInstance().createIteratorWithOperator({
                                        pdTypeName: pdTypeName,
                                        properties: ['ObjectIdentValue'],
                                        filter: filter ? JSON.stringify(filter) : null,
                                        orderby: this.convertOrderStatementWithoutAssociation(this.orderStatement),
                                        retrieveExtentCount: true,
                                        contextPDO_ID: this.context.genericObject.pdoId,
                                        itOperator: {
                                            includeAllPrincipals: this.detailViewItem.listView.includeAllPrincipals,
                                            includeBasePrincipals: this.detailViewItem.listView.includeBasePrincipals,
                                            includeSubPrincipals: this.detailViewItem.listView.includeSubPrincipals,
                                            memoryOptimizationEnabled: true,
                                            onlySubPrincipals: null,
                                            historizationDates: null,
                                            isGridIterator: null,
                                            principalFilter: null,
                                            searchObjectPositionRequest: null,
                                            visibleDeletedObjects: null,
                                            hideConnectedElementsRequest: null
                                        }
                                    }).then((iterator) => {
                                        this.iterator = iterator;
                                        if (this.isDisposed || this.iterator.extentCount <= 0) {
                                            return undefined;
                                        }
                                        return RADEnvironmentProxy.getInstance().getExtentWithPDOIDAsFirstColumn({
                                            iteratorID: this.iterator.id,
                                            start: 0,
                                            end: Math.min(this.iterator.extentCount - 1, this.maxSuggestions - 1)
                                        });
                                    }).then((arrayOfGeneric) => {
                                        if (this.isDisposed) {
                                            return;
                                        }
                                        let result = [];
                                        if (arrayOfGeneric) {
                                            for (let i = 0; i < arrayOfGeneric.length; i++) {
                                                result.push({
                                                    pdoId: arrayOfGeneric[i][0],
                                                    objectIdentValue: arrayOfGeneric[i][1]
                                                });
                                            }
                                        }
                                        options.success(result);
                                    }).always(() => {
                                        if (!this.isDisposed) {
                                            this.isBusy(false);
                                        }
                                    });
                                }
                            },
                            serverFiltering: true,
                            serverSorting: true
                        });
                    })(),
                    values: this.defineAsyncComputed(() => {
                        let result = [];
                        if (this.pdoId()) {
                            result.push({
                                pdoId: this.pdoId(),
                                objectIdentValue: this.objectIdentValue()
                            });
                        }
                        return result;
                    }),
                    onConnect: (toPDOID) => {
                        this.OnConnection([toPDOID]);
                    },
                    onDisconnect: (toPDOID) => {
                        this.OnDisconnection([toPDOID]);
                    },
                    onOpen: () => {
                        if (this.detailViewItem.listView.staticFilterExpression != '')
                            this.viewModel.multiSelectAutoComplete.dataSource.read();
                    },
                    isEnabled: this.isEnabled,
                    isValid: this.isValid,
                    invalidationText: this.invalidationText
                }),
                linkCreate: new this.LinkViewModel({
                    parentLocator: this.locator,
                    locator: LocatorHelper.buildLocator(this.detailViewItem.name, 'link.create'),
                    tooltip: new this.LabelViewModel({
                        ergName: 'CREATE_NEW_AND_CONNECT_TOOLTIP'
                    }),
                    image: new this.ImageViewModel({
                        parentLocator: this.locator,
                        locator: LocatorHelper.buildLocator(this.detailViewItem.name, 'link.create.image'),
                        source: Config.inlineImages.OBJ_CREATE,
                        alternativeText: new this.LabelViewModel({
                            ergName: 'CREATE_NEW_AND_CONNECT_TOOLTIP'
                        })
                    }),
                    onClick: () => {
                        if (!this.IsValidItemSelected()) {
                            $.when(this.context.notifyBeforeUpdatedAssociation(
                                this.detailViewItem.listView.relationName,
                                'connect', { toPdoIds: [null] }))
                                .then((doUpdateAssociation) => {
                                    if (doUpdateAssociation == null || doUpdateAssociation === true) {
                                        this.context.createContext(this, this.detailViewItem.listView, null, null, null, null, this.isModalCreating);
                                    }
                                });
                        }
                        else {
                            let contextPdoId = this.context.genericObject.pdoId;
                            let associationName = this.detailViewItem.listView.relationName;
                            let pdTypeName = this.detailViewItem.listView.typeName;
                            this._objectHelper = new this.ObjectCreationHelper({
                                contextPdoId: contextPdoId,
                                associationName: associationName,
                                pdTypeName: pdTypeName,
                                affectedObjectIds: [this.pdoId()],
                                creationCallback: () => {
                                    $.when(this.context.notifyBeforeUpdatedAssociation(associationName, 'connect', { toPdoIds: [null] }))
                                        .then((doUpdateAssociation) => {
                                            if (doUpdateAssociation == null || doUpdateAssociation === true) {
                                                this.context.createContext(this, this.detailViewItem.listView, null, null, null, null, this.isModalCreating);
                                            }
                                        });
                                },
                                confirmDeletionCallback: this.OnConfirmDeletionCallback.bind(this)
                            });
                            this._objectHelper.ExecuteCheck();
                        }
                    },
                    isFocusable: this.isFocusable,
                    isVisible: this.defineComputed(() => {
                        return this.isEnabled() && this.detailViewItem.listView.showButtonCreate;
                    }),
                    isToolBarLink: true,
                    isEnabled: this.isEnabled
                }),
                linkSelect: new this.LinkViewModel({
                    parentLocator: this.locator,
                    locator: LocatorHelper.buildLocator(this.detailViewItem.name, 'link.select'),
                    tooltip: new this.LabelViewModel({
                        ergName: 'FIND_AND_CONNECT_TOOLTIP'
                    }),
                    image: new this.ImageViewModel({
                        parentLocator: this.locator,
                        locator: LocatorHelper.buildLocator(this.detailViewItem.name, 'link.select.image'),
                        source: Config.inlineImages.OBJ_SELECT,
                        alternativeText: new this.LabelViewModel({
                            ergName: 'FIND_AND_CONNECT_TOOLTIP'
                        })
                    }),
                    isFocusable: this.isFocusable,
                    onClick: () => {
                        if (this.viewFactorySearchListView != null) {
                            return;
                        }
                        this.viewFactorySearchListView = NavigationService.getInstance().loadViewFactoryIsolated('SearchListView', {
                            viewModel: new this.SearchListViewViewModel({
                                parentLocator: this.locator,
                                locator: LocatorHelper.buildLocator(this.detailViewItem.name, 'selectview'),
                                listView: this.detailViewItem.listView,
                                contextPdoId: this.context.genericObject.pdoId,
                                allowMultiSelect: false,
                                associationName: this.detailViewItem.listView.relationName,
                                callback: (toPDOIDs) => {
                                    if (toPDOIDs && toPDOIDs.length > 0) {
                                        this.OnConnection(toPDOIDs);
                                    }
                                },
                                onClose: () => {
                                    associationSingleAutocompleteBoxViewModel.linkSelect.hasFocus(true);
                                    NavigationService.getInstance().removeViewFactoryIsolated(this.viewFactorySearchListView);
                                    this.viewFactorySearchListView = null;
                                }
                            })
                        }, true);
                    },
                    isVisible: this.defineComputed(() => {
                        return this.isEnabled() && this.detailViewItem.listView.showButtonSelect;
                    }),
                    isToolBarLink: true,
                    isEnabled: this.isEnabled
                }),
                linkEdit: new this.LinkViewModel({
                    parentLocator: this.locator,
                    locator: LocatorHelper.buildLocator(this.detailViewItem.name, 'link.edit'),
                    image: new this.ImageViewModel({
                        parentLocator: this.locator,
                        locator: LocatorHelper.buildLocator(this.detailViewItem.name, 'link.edit.image'),
                        source: Config.inlineImages.OBJ_EDIT,
                        alternativeText: new this.LabelViewModel({
                            ergName: 'EDIT_CONNECTED_TOOLTIP'
                        })
                    }),
                    isEnabled: this.defineComputed(() => {
                        return this.pdoId() != null && this.pdoId() != this.detailViewItem.disableNavigation;
                    }),
                    onClick: () => {
                        this.context.createContext(this, this.detailViewItem.listView, this.pdoId());
                    },
                    tooltip: new this.LabelViewModel({
                        ergName: 'EDIT_CONNECTED_TOOLTIP'
                    }),
                    isVisible: this.detailViewItem.listView.showButtonEdit,
                    isFocusable: this.isFocusable,
                    isToolBarLink: true
                }),
                linkDisconnect: new this.LinkViewModel({
                    parentLocator: this.locator,
                    locator: LocatorHelper.buildLocator(this.detailViewItem.name, 'link.disconnect'),
                    image: new this.ImageViewModel({
                        parentLocator: this.locator,
                        locator: LocatorHelper.buildLocator(this.detailViewItem.name, 'link.disconnect.image'),
                        source: Config.inlineImages.OBJ_DISCONNECT,
                        alternativeText: new this.LabelViewModel({
                            ergName: 'DISCONNECT_TOOLTIP'
                        })
                    }),
                    isEnabled: this.defineComputed(() => {
                        return this.isEnabled() && this.pdoId() != null;
                    }),
                    onClick: () => {
                        this.OnDisconnection([this.pdoId()]);
                    },
                    tooltip: new this.LabelViewModel({
                        ergName: 'DISCONNECT_TOOLTIP'
                    }),
                    isVisible: this.defineComputed(() => {
                        return this.isEnabled() && this.detailViewItem.listView.showButtonDisconnect;
                    }),
                    isFocusable: this.isFocusable,
                    isToolBarLink: true
                }),
                linkDelete: new this.LinkViewModel({
                    parentLocator: this.locator,
                    locator: LocatorHelper.buildLocator(this.detailViewItem.name, 'link.delete'),
                    image: new this.ImageViewModel({
                        parentLocator: this.locator,
                        locator: LocatorHelper.buildLocator(this.detailViewItem.name, 'link.delete.image'),
                        source: Config.inlineImages.OBJ_DELETE,
                        alternativeText: new this.LabelViewModel({
                            ergName: 'DISCONNECT_AND_DELETE_TOOLTIP'
                        })
                    }),
                    isEnabled: this.defineComputed(() => {
                        return this.isEnabled() && this.pdoId() != null;
                    }),
                    tooltip: new this.LabelViewModel({
                        ergName: 'DISCONNECT_AND_DELETE_TOOLTIP'
                    }),
                    onClick: () => {
                        if (this.IsValidItemSelected()) {
                            let pdTypeName = this.detailViewItem.listView.typeName;
                            let associationName = this.detailViewItem.listView.relationName;
                            let deletionHelper = new this.ObjectDeletionHelper({
                                pdTypeName: pdTypeName,
                                affectedObjectIds: [this.pdoId()],
                                confirmDeletionCallback: this.OnConfirmDeletionCallback.bind(this)
                            });
                            deletionHelper.ExecuteCheck();
                        }
                    },
                    isVisible: this.defineComputed(() => {
                        return this.isEnabled() && this.detailViewItem.listView.showButtonDelete;
                    }),
                    isFocusable: this.isFocusable,
                    isToolBarLink: true
                }),
                disconnectItem: () => {
                    this.OnDisconnection([this.pdoId()]);
                }
            });
            return associationSingleAutocompleteBoxViewModel;
        })();
        this.defineSubscription(this.viewModel.multiSelectAutoComplete.values, (newValues) => {
            this.viewModel.multiSelectAutoComplete.dataSource.read();
        });
        this.control = (() => {
            return new this.AssociationSingleAutocompleteBox(this.viewModel);
        })();
        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;
        this.registerObservableValidation(this.viewModel.multiSelectAutoComplete.values);
        return this.jQueryControl;
    }
    public notifyDetailViewClosed(topdTypeName?: any, toPDOID?: any): void {
        RADEnvironmentProxy.getInstance().getPropertiesForDetailViewContext({
            detailViewContextID: this.context.id,
            pdoID: this.context.genericObject.pdoId,
            properties: [this.detailViewItem.name + '.ObjectIdentValue', this.detailViewItem.name + '.PDO_ID']
        }).then((properties) => {
            if (this.validateStatus(properties)) {
                let oldPdoID = this.pdoId();
                let newPdoID = properties.returnValue[this.detailViewItem.name + '.PDO_ID'];
                this.pdoId(newPdoID);
                this.objectIdentValue(properties.returnValue[this.detailViewItem.name + '.ObjectIdentValue']);
                if (oldPdoID != newPdoID) {
                    this.context.notifyUpdatedAssociation(this.detailViewItem.listView.relationName);
                    this.context.notifyFactoryRefreshed(this.detailViewItem);
                }
            }
        });
    }
    public refreshAssociation(): void {
        this.forceReloadData = true;
        this.viewModel.multiSelectAutoComplete.values.evaluate();
        this.context.genericObject.refreshProperties([this.detailViewItem.name + '.ObjectIdentValue', this.detailViewItem.name + '.PDO_ID']);
    }
    /** @overrides */
    protected disposeInternal(): void {
        this.deleteIterator(this.iterator);
        if (this.viewFactorySearchListView != null && !this.viewFactorySearchListView.isDisposed) {
            NavigationService.getInstance().removeViewFactory(this.viewFactorySearchListView);
        }
        super.disposeInternal();
    }
    /** @implements */
    public refresh(): void {
        this.refreshAssociation();
    }
    public getValueForFilter(): any {
        let ret = {};
        ret[this.detailViewItem.name + '.ObjectIdentValue'] = this.objectIdentValue();
        ret[this.detailViewItem.name + '.PDO_ID'] = this.pdoId();
        return ret;
    }
    public getFilterInfo(): any {
        return {
            field: this.detailViewItem.name + '.PDO_ID',
            value: this.pdoId() || ''
        };
    }
    public resetValue(): any {
        this.OnDisconnection([this.pdoId()]);
    }
    public deleteIterator(iterator: any): any {
        if (this.isDisposed || iterator == null)
            return;
        RADEnvironmentProxy.getInstance().deleteIterator({
            iteratorID: iterator.id
        });
    }
    private assembleFilter(options: any, pdTypeName: any): any {
        if (!options.data.filter || options.data.filter.filters.length <= 0 || options.data.filter.filters[0].value === '') {
            return pdTypeName != null ? FilterHelper.createFilterObjectForStaticFilter(this.detailViewItem.listView.staticFilterExpression) : null;
        }
        let filterValue = options.data.filter.filters[0].value;
        if (pdTypeName != null) {
            let staticFilter = this.detailViewItem.listView.staticFilterExpression;
            let searchFields = this.searchFields.split(',');
            let filterObj = {
                staticFilter: staticFilter,
                components: []
            };
            searchFields.forEach((field) => {
                field = field.trim();
                let operator;
                if (this.containsMode === true) {
                    operator = 'LIKE';
                } else {
                    operator = '=';
                }
                let filterTerm = { property: field, value: filterValue, operator: operator };
                filterObj.components.push({ filter: filterTerm, connector: "OR" })
            });
            return filterObj;
        }
    }
    private OnDisconnection(pdoIds: any): any {
        if (this.IsValidItemSelected()) {
            let contextId = this.context.genericObject.pdoId;
            if (+contextId > 0) {
                let disconnectionHelper = new this.ObjectDisconnectionHelper({
                    contextPdoId: this.context.genericObject.pdoId,
                    associationName: this.detailViewItem.listView.relationName,
                    pdTypeName: this.detailViewItem.listView.typeName,
                    affectedObjectIds: pdoIds,
                    disconnectionCallback: this.OnDisconnectionCallback.bind(this),
                    confirmDeletionCallback: this.OnConfirmDeletionCallback.bind(this)
                });
                disconnectionHelper.ExecuteCheck();
            } else {
                this.pdoId(null);
                this.objectIdentValue(null);
            }
        }
    }
    private OnDisconnectionCallback(): any {
        $.when(this.context.notifyBeforeUpdatedAssociation(this.detailViewItem.listView.relationName, 'disconnect', { toPdoIds: [this.pdoId()] }))
            .then((doUpdateAssociation) => {
                if (doUpdateAssociation == null || doUpdateAssociation === true) {
                    Loader.getInstance().show();
                    RADEnvironmentProxy.getInstance().disconnect({
                        pdoID: this.context.genericObject.pdoId,
                        assoziationName: this.detailViewItem.listView.relationName,
                        topdTypeName: this.detailViewItem.listView.typeName,
                        toPDOID: this.pdoId(),
                        nestedContextName: this.context.getNestedContextPath()
                    }).then((changeObject) => {
                        if (this.validateStatus(changeObject)) {
                            this.pdoId(null);
                            this.context.genericObject.isModified(true);
                            this.context.notifyUpdatedAssociation(this.detailViewItem.listView.relationName);
                            this.context.notifyFactoryRefreshed(this.detailViewItem);
                        } else {
                            this.refreshAssociation();
                        }
                    }).always(() => {
                        Loader.getInstance().hide();
                    });
                }
            });
    }
    private OnConnection(toPDOIDs: any): any {
        if (!toPDOIDs)
            return;
        let selPdoId = toPDOIDs[0];
        if (!this.IsValidItemSelected()) {
            this.OnConnectionCallback(selPdoId);
        }
        else {
            let currentItem = [this.pdoId()];
            let associationName = this.detailViewItem.listView.relationName;
            let pdTypeName = this.detailViewItem.listView.typeName;
            this._objectHelper = new this.ObjectConnectionHelper({
                contextPdoId: this.context.genericObject.pdoId,
                associationName: associationName,
                pdTypeName: pdTypeName,
                affectedObjectIds: currentItem,
                objectIdToConnect: selPdoId,
                connectionCallback: this.OnConnectionCallback.bind(this),
                confirmDeletionCallback: this.OnConfirmDeletionCallback.bind(this)
            });
            this._objectHelper.ExecuteCheck();
        }
    }
    private OnConnectionCallback(objectIdToConnect: any): any {
        $.when(this.context.notifyBeforeUpdatedAssociation(this.detailViewItem.listView.relationName, 'connect', { toPdoIds: [objectIdToConnect] }))
            .then((doUpdateAssociation) => {
                if (doUpdateAssociation == null || doUpdateAssociation === true) {
                    Loader.getInstance().show();
                    let contextId = this.context.genericObject.pdoId;
                    if (+contextId > 0) {
                        RADEnvironmentProxy.getInstance().connect({
                            pdoID: contextId,
                            assoziationName: this.detailViewItem.listView.relationName,
                            topdTypeName: this.detailViewItem.listView.typeName,
                            toPDOID: objectIdToConnect,
                            nestedContextName: this.context.getNestedContextPath()
                        }).then((changeObject) => {
                            if (this.validateStatus(changeObject)) {
                                this.pdoId(objectIdToConnect);
                                this.objectIdentValue(changeObject.returnValue);
                                this.context.genericObject.isModified(true);
                                this.context.notifyUpdatedAssociation(this.detailViewItem.listView.relationName);
                                this.context.notifyFactoryRefreshed(this.detailViewItem);
                            } else {
                                this.refreshAssociation();
                            }
                        }).always(() => {
                            Loader.getInstance().hide();
                            this.RemoveObjectHelper();
                        });
                    } else {
                        RADEnvironmentProxy.getInstance().getObject({
                            pdTypeName: this.detailViewItem.listView.typeName,
                            pdoID: objectIdToConnect,
                            properties: ['ObjectIdentValue']
                        }).then((genericDTO) => {
                            this.pdoId(objectIdToConnect);
                            this.objectIdentValue(genericDTO.values['ObjectIdentValue']);
                        }).always(() => {
                            Loader.getInstance().hide();
                            this.RemoveObjectHelper();
                        });
                    }
                }
            });
    }
    private OnConfirmDeletionCallback(dialogResult: any): any {
        if (dialogResult === true) {
            if (this.IsValidItemSelected()) {
                let associationName = this.detailViewItem.listView.relationName;
                $.when(this.context.notifyBeforeUpdatedAssociation(associationName, 'disconnectAndDelete', { toPdoIds: [this.pdoId()] }))
                    .then((doUpdateAssociation) => {
                        if (doUpdateAssociation == null || doUpdateAssociation === true) {
                            Loader.getInstance().show();
                            let pdTypeName = this.detailViewItem.listView.typeName;
                            RADEnvironmentProxy.getInstance().deleteObject({
                                pdTypeName: pdTypeName,
                                pdoID: this.pdoId()
                            }).then((changeObject) => {
                                if (this.validateStatus(changeObject)) {
                                    this.pdoId(null);
                                    this.context.genericObject.isModified(true);
                                    this.context.notifyUpdatedAssociation(associationName);
                                    this.context.notifyFactoryRefreshed(this.detailViewItem);
                                    if (this._objectHelper) {
                                        this._objectHelper.ExecuteAction();
                                    }
                                }
                            }).always(() => {
                                this.RemoveObjectHelper();
                                Loader.getInstance().hide();
                            });
                        }
                    });
            }
        }
        else {
            this.RemoveObjectHelper();
        }
    }
    private IsValidItemSelected(): any {
        return this.pdoId() && this.pdoId() >= 0;
    }
    private RemoveObjectHelper(): any {
        if (this._objectHelper && !this._objectHelper.isDisposed) {
            this._objectHelper.dispose();
            this._objectHelper = null;
        }
    }
}

ComponentManager.setFactory('AssociationSingleAutocompleteBox', AssociationSingleAutocompleteBoxFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');